export interface CurrencyFormat {
  amount: number;
  suffix: string;
  formattedString: string;
  exactAmount: number;
}

export function formatCurrencySuffix(
  amount: number,
  currencySymbol = "$"
): CurrencyFormat {
  if (amount < 1000) {
    return {
      amount: amount,
      suffix: "",
      formattedString: `${currencySymbol}${amount}`,
      exactAmount: amount,
    };
  }

  const suffixes = ["", "K", "M", "B", "T"];
  let tier = Math.floor(Math.log10(Math.abs(amount)) / 3);

  if (tier >= suffixes.length) tier = suffixes.length - 1;

  const scaledAmount = (amount / Math.pow(1000, tier)).toFixed(2);

  return {
    amount: parseFloat(scaledAmount),
    exactAmount: amount,
    suffix: suffixes[tier],
    formattedString: `${currencySymbol}${scaledAmount}${suffixes[tier]}`,
  };
}
